'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { HR } from 'foundations-components/transitional/components/HR';
import ForecastBar from './ForecastBar';
import { forecastStagesType } from '../ForecastUtils';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollingDiv = styled.div.withConfig({
  displayName: "StackedForecast__ScrollingDiv",
  componentId: "sc-1tbey41-0"
})(["max-height:100%;height:100%;overflow:auto;"]);
const StackedForecast = ({
  currencyCode,
  total,
  quota,
  stages,
  onDrilldown,
  isMobile
}) => {
  const quotaTotalMobile = quota != null && isMobile ? /*#__PURE__*/_jsxs(Text, {
    as: "span",
    typography: "body-125",
    children: [I18n.text('reporting-ui-components.customWidgets.forecastWidget.quotaLabel'), "\xA0", /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
        value: quota,
        precision: 0,
        currencyCode: currencyCode
      })
    })]
  }) : null;
  return /*#__PURE__*/_jsxs(ScrollingDiv, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush",
      marginBlockEnd: "400"
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "baseline",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: isMobile ? 'heading-400' : 'heading-500',
        color: "do-not-use-slinky",
        children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          currencyCode: currencyCode,
          value: total,
          precision: 0
        })
      }), quotaTotalMobile]
    }), /*#__PURE__*/_jsx(ForecastBar, {
      quota: quota,
      stages: stages,
      currencyCode: currencyCode,
      onDrilldown: onDrilldown,
      isMobile: isMobile
    })]
  });
};
StackedForecast.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  quota: PropTypes.number,
  stages: forecastStagesType.isRequired,
  onDrilldown: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
};
export default StackedForecast;